import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import { teamMemberSummarySchema, teamMemberSummaryListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import {
  loadingStart,
  loadingFinish,
  actionConfirmed,
} from 'app/ducks/loading/actions';
import {
  sagaActions,
} from 'app/ducks/teamMemberSummaries/actions';
import { TeamMemberSummariesActionTypes as types } from 'app/ducks/teamMemberSummaries/types';

function* createTeamMemberSummariesaga(action): any {
  yield put(sagaActions.createTeamMemberSummaryPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).teamMemberSummaries.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, teamMemberSummarySchema);

    yield put(sagaActions.createTeamMemberSummariesSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createTeamMemberSummaryFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updateTeamMemberSummariesaga(action): any {
  yield put(sagaActions.updateTeamMemberSummaryPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).teamMemberSummaries.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, teamMemberSummarySchema);

    yield put(sagaActions.updateTeamMemberSummariesSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateTeamMemberSummaryFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* deleteTeamMemberSummariesaga(action): any {
  yield put(sagaActions.deleteTeamMemberSummaryPending(action.payload.id));
  const [error, response] = yield (yield TeammoApi(yield select())).teamMemberSummaries.delete(
    action.payload,
  );

  if (response || _.isEmpty(error)) {
    // const normalizedResponse = normalize(response, teamMemberSummarySchema);
    yield put(actionConfirmed('Team member deleted'));
    yield put(sagaActions.deleteTeamMemberSummariesSuccess(action.payload.id));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.deleteTeamMemberSummaryFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getTeamMemberSummariesaga(action): any {
  yield put(sagaActions.getTeamMemberSummaryPending());
  const [error, response] = yield (yield TeammoApi(yield select())).teamMemberSummaries.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, teamMemberSummarySchema);
    yield put(sagaActions.getTeamMemberSummariesSuccess(normalizedResponse));
    return normalizedResponse.entities.teamMemberSummaries[normalizedResponse.result];
  }
  yield put(
    handleError(error, sagaActions.getTeamMemberSummaryFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

function* getAllTeamMemberSummariesSaga(action): any {
  yield put(
    sagaActions.getAllTeamMemberSummariesPending(action.payload.compile ? action.payload.pagination : {}),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(yield select((state) => state.teamMemberSummaries.pagination))
    : action.payload.pagination;
  let teammoApi = TeammoApi(yield select());

  if (action.payload.teamMemberSummaryView) {
    teammoApi = TeammoApi(yield select(), null, null, false, false, {
      'team-member-code': action.payload.teamMemberSummaryCode,
      'team-code': action.payload.teamCode,
    });
  }
  const [error, response] = yield (yield teammoApi).teamMemberSummaries.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(response, teamMemberSummaryListSchema);

    yield put(
      sagaActions.getAllTeamMemberSummariesSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(error, sagaActions.getAllTeamMemberSummariesFailed(_.isEmpty(error) ? {} : error.response.data.errors));
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createTeamMemberSummariesagaWatcher(): any {
  yield takeLatest(types.CREATE_TEAM_MEMBER_SUMMARY_REQUESTED, createTeamMemberSummariesaga);
}

function* updateTeamMemberSummariesagaWatcher(): any {
  yield takeLatest(types.UPDATE_TEAM_MEMBER_SUMMARY_REQUESTED, updateTeamMemberSummariesaga);
}

function* deleteTeamMemberSummariesagaWatcher(): any {
  yield takeLatest(types.DELETE_TEAM_MEMBER_SUMMARY_REQUESTED, deleteTeamMemberSummariesaga);
}

function* getTeamMemberSummariesagaWatcher(): any {
  yield takeLatest(types.GET_TEAM_MEMBER_SUMMARY_REQUESTED, getTeamMemberSummariesaga);
}

function* getAllTeamMemberSummariesSagaWatcher(): any {
  yield takeLatest(types.GET_ALL_TEAM_MEMBER_SUMMARY_SUMMARIES_REQUESTED, getAllTeamMemberSummariesSaga);
}

export default function* root(): any {
  yield all([
    createTeamMemberSummariesagaWatcher(),
    updateTeamMemberSummariesagaWatcher(),
    deleteTeamMemberSummariesagaWatcher(),
    getTeamMemberSummariesagaWatcher(),
    getAllTeamMemberSummariesSagaWatcher(),
  ]);
}
